import { Link, useLocation } from "react-router-dom";
import "../dashboard/Styles/Components.css";
import { useEffect, useState } from "react";
import { AiOutlineFileText } from "react-icons/ai";
import DomainDisabledOutlinedIcon from "@mui/icons-material/DomainDisabledOutlined";
import permissionConfig from "../dashboard/permissionConfig";
import { useAuth } from "../../context/AuthContext";
const SidebarData = ({ toggle }) => {
  const location = useLocation();
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const { auth } = useAuth();
  const [menuItems, setMenuItems] = useState([
    // {
    //   name: "Dashboard",
    //   icon: require("../dashboard/images/home (2).png"),
    //   path: "/dashboard",
    // },
    {
      name: "Settings",
      icon: require("../dashboard/images/setting.png"),
      path: "/settings",
      subMenu: [
        {
          name: "Services",
          icon: <AiOutlineFileText />,
          path: "/settings/services",
        },
        {
          name: "Languages",
          icon: <AiOutlineFileText />,
          path: "/settings/languages",
        },
        {
          name: "Location",
          icon: <AiOutlineFileText />,
          path: "/settings/prefered-zone",
        },
        {
          name: "Status",
          icon: <AiOutlineFileText />,
          path: "/settings/status",
        },
        {
          name: "Googlemapkey",
          icon: <AiOutlineFileText />,
          path: "/settings/googlemapkey",
        },
        {
          name: "Available-Shifts",
          icon: <AiOutlineFileText />,
          path: "/settings/availble-shifts",
        },
        {
          name: "Days-Available",
          icon: <AiOutlineFileText />,
          path: "/settings/days-available",
        },
        {
          name: "Education-Levels",
          icon: <AiOutlineFileText />,
          path: "/settings/education-levels",
        },
        {
          name: "Hospital Facility",
          icon: <AiOutlineFileText />,
          path: "/settings/hospital-facilities",
        },
        {
          name: "Facility Service",
          icon: <AiOutlineFileText />,
          path: "/settings/facility-service",
        },
        {
          name: "States",
          icon: <AiOutlineFileText />,
          path: "/settings/states",
        },
        {
          name: "Districts",
          icon: <AiOutlineFileText />,
          path: "/settings/districts",
        },
        {
          name: "Cities",
          icon: <AiOutlineFileText />,
          path: "/settings/cities",
        },
        {
          name: "Co-ordinators",
          icon: <AiOutlineFileText />,
          path: "/settings/co-ordinator",
        },
        {
          name: "Managers",
          icon: <AiOutlineFileText />,
          path: "/settings/managers",
        },
        {
          name: "Lead-Source",
          icon: <AiOutlineFileText />,
          path: "/settings/lead-source",
        },
        {
          name: "Interaction-Type",
          icon: <AiOutlineFileText />,
          path: "/settings/interaction-type",
        },
        {
          name: "Interaction-Channel",
          icon: <AiOutlineFileText />,
          path: "/settings/interaction-channel",
        },
        {
          name: "Interaction-Outcome",
          icon: <AiOutlineFileText />,
          path: "/settings/interaction-outcome",
        },
        {
          name: "FollowUpMode",
          icon: <AiOutlineFileText />,
          path: "/settings/followupmode",
        },
        {
          name: "ResourceType",
          icon: <AiOutlineFileText />,
          path: "/settings/resourcetype",
        },
        {
          name: "AssessmentType",
          icon: <AiOutlineFileText />,
          path: "/settings/assessment-type",
        },
        {
          name: "AssessmentMode",
          icon: <AiOutlineFileText />,
          path: "/settings/assessment-mode",
        },
        {
          name: "RiskCategory",
          icon: <AiOutlineFileText />,
          path: "/settings/risk-category",
        },
        {
          name: "ResourceCategory",
          icon: <AiOutlineFileText />,
          path: "/settings/resource-category",
        },
        {
          name: "Relations",
          icon: <AiOutlineFileText />,
          path: "/settings/relations",
        },
        {
          name: "Tariffs",
          icon: <AiOutlineFileText />,
          path: "/settings/tariffs",
        },
      ],
    },
    {
      name: "Work List",
      icon: require("../dashboard/images/branches.png"),
      path: "/worklist",
      subMenu: [
        {
          name: "My Work List",
          icon: <AiOutlineFileText />,
          path: "/worklist/myworklist",
        },
        {
          name: "Carepreneur",
          icon: <AiOutlineFileText />,
          path: "/worklist/carepreneur",
        },
        {
          name: "Hospital",
          icon: <AiOutlineFileText />,
          path: "/worklist/hospital",
        },
      ],
    },
    {
      name: "Marketing",
      icon: <DomainDisabledOutlinedIcon style={{ verticalAlign: "middle" }} />,
      path: "/marketing",
      subMenu: [
        {
          name: "Blog Categories",
          icon: <AiOutlineFileText />,
          path: "/marketing/blog-categories",
        },
        {
          name: "Blog Posts",
          icon: <AiOutlineFileText />,
          path: "/marketing/blog-posts",
        },
        {
          name: "Contacts",
          icon: <AiOutlineFileText />,
          path: "/marketing/contacts",
        },
        {
          name: "Seo-Url",
          icon: <AiOutlineFileText />,
          path: "/marketing/seo-url",
        },
      ],
    },
  ]);

  useEffect(() => {
    const role = auth?.role;
    const config = permissionConfig.find((item) => item.role === role);

    if (config) {
      const updatedMenu = menuItems
        .filter((item) => config.show.includes(item.name))
        .sort(
          (a, b) => config.show.indexOf(a.name) - config.show.indexOf(b.name),
        )
        .map((item) => ({
          ...item,
          active: location.pathname.startsWith(item.path),
        }));

      setMenuItems(updatedMenu);
    }
  }, [location.pathname]);

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  return (
    <div className={toggle ? "sidebar" : "sidebar-hide"}>
      <ul className="menu">
        {menuItems.map((item, index) => (
          <li key={index}>
            <Link
              to={item.subMenu ? "#" : item.path}
              className={`menu-item ${item.active ? "active" : ""}`}
              onClick={(e) => {
                if (item.subMenu) {
                  e.preventDefault();
                  toggleDropdown(index);
                }
              }}
            >
              <div className="icon-container">
                {typeof item.icon === "string" ? (
                  <img src={item.icon} alt={item.name} />
                ) : (
                  item.icon
                )}
              </div>
              {item.name}
              {item.subMenu && (
                <span style={{ marginLeft: "auto" }}>
                  {openDropdownIndex === index ? "▲" : "▼ "}
                </span>
              )}
            </Link>

            {item.subMenu && openDropdownIndex === index && (
              <ul className="submenu">
                {item.subMenu.map((subItem, subIndex) => (
                  <li key={subIndex}>
                    <Link
                      to={subItem.path}
                      className={`menu-item ${
                        location.pathname.startsWith(subItem.path)
                          ? "active"
                          : ""
                      }`}
                    >
                      {subItem.icon}
                      {subItem.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SidebarData;
